module.exports = __webpack_public_path__ + "img/notification-clock.1e7e9ee0.svg";